// Wrap tables in a responsive container and remove inline styles
document.addEventListener('DOMContentLoaded', function() {
  const postContent = document.querySelector('.post-content');
  
  if (postContent) {
    const tables = postContent.querySelectorAll('table');
    
    tables.forEach(function(table) {
      // Remove inline width styles that break responsive layout
      table.removeAttribute('width');
      table.removeAttribute('style');
      
      // Remove inline styles from table cells
      const cells = table.querySelectorAll('th, td');
      cells.forEach(function(cell) {
        // Keep alignment but remove width and other problematic styles
        const align = cell.getAttribute('align');
        cell.removeAttribute('style');
        cell.removeAttribute('width');
        if (align) {
          cell.style.textAlign = align;
        }
      });
      
      // Check if table is not already wrapped
      if (!table.parentElement.classList.contains('table-wrapper')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'table-wrapper';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      }
    });
  }
});
